import axios from 'axios'
import { getHost } from './host'

export interface Site {
  site_id: number;
  customer_id: number;
}

export interface CreateSite {
  site_id: number;
  customer_id: number;
}

export async function getSiteCustomer(api_key: string, site_id: number) {
  const url = `https://${getHost()}/api/site/${site_id}/customer`

  const { data } = await axios.get<{ data: Site }>(url, { headers: {'X-API-KEY': api_key, Accept: 'application/json'} });
  return data.data
}

export async function updateSiteCustomer(api_key: string, site_id: number, customer_id: number) {
  var url = `https://${getHost()}/api/site/${site_id}/customer`

  const bodyFormData = new FormData();

  bodyFormData.append('customer_id', customer_id.toString());
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<{ data: Site }>(url, bodyFormData, { headers: headers });
  
  return data.data
}

export async function updateSite(api_key: string, site: CreateSite) {
  var url = `https://${getHost()}/api/site/${site.site_id}/customer`

  const bodyFormData = new FormData();

  bodyFormData.append('customer_id', site.customer_id.toString());
  
  const headers = {
    'X-API-KEY': api_key, Accept: 'application/json'
  };

  const { data } = await axios.post<Site>(url, bodyFormData, { headers: headers });
  
  return data
}